import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root',
})

export class OneTrustCokkiesService {


	constructor() {
	}
	public loadScript({id, key}) {
        return new Promise((resolve, reject) => {
        if(id && document.getElementById(id)) {
            resolve({id: id, loaded: true, status: 'Already Loaded'});
        }
        let body =  document.body;
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.charset = 'UTF-8';
        script.innerHTML = '';
        script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        script.id = id;
        script.setAttribute("data-domain-script", key);
        script.setAttribute("data-document-language", "true");
        script.onload =() => {
            resolve({id: id, loaded: true, status: 'Loaded'});
        };
        script.onerror = (error: any) => resolve({id: id, loaded: false, status: 'Loaded'});
        script.async = true;
        script.defer = true;
        body.appendChild(script);
    });
  }

  public optanonWrapper({ id }) {
    return new Promise((resolve, reject) => {
        if(id && document.getElementById(id)) {
            resolve({id: id, loaded: true, status: 'Already Loaded'});
        }
        let body =  document.body;
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.innerHTML = `
        // OneTrust Cookies Consent Notice start for areaprivada.renaultbank.es
        function OptanonWrapper() {
        // 1. Initialisation des groupes si nécessaire
    if (typeof OptanonWrapperCount == "undefined") {
        otGetInitialGrps();
    }

    // 2. Lancement de la suppression
    otDeleteCookie(otIniGrps);

    function otGetInitialGrps() {
        OptanonWrapperCount = '';
        if (window.Optanon && window.Optanon.GetDomainData()) {
            otIniGrps = window.Optanon.GetDomainData().Groups.map(function(obj) {
                return obj.OptanonGroupId !== undefined ? obj.OptanonGroupId : null;
            });
        }
    }

    function otDeleteCookie(iniOptGrpId) {
        var otDomainData = window.Optanon.GetDomainData();
        if (!otDomainData) return;

        var otDomainGrps = JSON.parse(JSON.stringify(otDomainData.Groups));
        var otDeletedGrpIds = otGetInactiveId(iniOptGrpId, window.OnetrustActiveGroups || "");

        if (otDeletedGrpIds.length != 0 && otDomainGrps.length != 0) {
            for (var i = 0; i < otDomainGrps.length; i++) {
                var group = otDomainGrps[i];

                // Vérification si le groupe a été désactivé
                if (otDeletedGrpIds.indexOf(group.CustomGroupId) !== -1 || otDeletedGrpIds.indexOf(group.OptanonGroupId) !== -1) {

                    // Suppression des cookies listés dans le groupe
                    if (group.Cookies && group.Cookies.length > 0) {
                        for (var j = 0; j < group.Cookies.length; j++) {
                            eraseCookie(group.Cookies[j].Name, group.Cookies[j].Host);
                        }
                    }

                    // Suppression des cookies par Hosts
                    if (group.Hosts && group.Hosts.length > 0) {
                        for (var h = 0; h < group.Hosts.length; h++) {
                            if (group.Hosts[h].Cookies && group.Hosts[h].Cookies.length > 0) {
                                for (var c = 0; c < group.Hosts[h].Cookies.length; c++) {
                                    eraseCookie(group.Hosts[h].Cookies[c].Name, group.Hosts[h].Cookies[c].Host);
                                }
                            }
                        }
                    }
                }
            }
        }
        otGetInitialGrps(); // Réassignation pour le prochain changement
    }

    function otGetInactiveId(customIniId, otActiveGrp) {
        var activeArr = otActiveGrp.split(",").filter(Boolean);
        var inactive = [];
        for (var i = 0; i < customIniId.length; i++) {
            if (activeArr.indexOf(customIniId[i]) === -1) {
                inactive.push(customIniId[i]);
            }
        }
        return inactive;
    }

    function eraseCookie(name, host) {
        var domainName = window.location.hostname;
        var domains = [domainName, "." + domainName, host, "." + host, ""];

        // On applique la suppression normale pour le nom fixe du cookie
        domains.forEach(function(d) {
            if(!d) return;
            document.cookie = name + '=; Max-Age=-99999999; Path=/; Domain=' + d + ';';

            // Tentative sur la hiérarchie des chemins (paths)
            var paths = window.location.pathname.split('/');
            var currentPath = '';
            for (var p = 0; p < paths.length; p++) {
                if (paths[p]) {
                    currentPath += '/' + paths[p];
                    document.cookie = name + '=; Max-Age=-99999999; Path=' + currentPath + '; Domain=' + d + ';';
                    document.cookie = name + '=; Max-Age=-99999999; Path=' + currentPath + '/; Domain=' + d + ';';
                }
            }
        });

        localStorage.removeItem(name);
    }
}



        `;
        script.id = id;
        script.onload =() => {
            resolve({id: id, loaded: true, status: 'Loaded'});
        };
        script.onerror = (error: any) => resolve({id: id, loaded: false, status: 'Loaded'});
        script.async = true;
        script.defer = true;
        body.appendChild(script);
    });
  }

  public removeScript(id: string) {
      let script = document.getElementById(id);
      if(script) {
          script.remove();
      }
  }
}
